import React from 'react'
// import cover from '../assets/svg/cover.svg'

const Layout = ({children}) => {
  return (
    <div className='layout'>
        {/* <header>
            <img src={cover} alt='cover' className='w-100'/>
        </header> */}
        <div className='h-100 d-flex justify-content-center align-items-center overflow-hidden custom-container'>
            <div className='contenedor-form'>
           {/* <div className='mb-5 layout__progress mx-auto'>
                <div className="progress rounded-pill">
                     <div className="progress-bar rounded-pill" role="progressbar" style={{width: `${percent}%`, background: "#22BCDA"}} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <div className='d-flex justify-content-between align-items-center pt-2'>
                    <span className='d-inline-block' style={{fontSize: '12px'}}>{currentPage}/{limitPage}</span>
                    <span className='d-inline-block' style={{fontSize: '12px'}}>{percent}%</span>
                </div>
           </div> */}
                {children}
            </div>
        </div>
    </div>
  )
}

export default Layout